import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import {
  AccordionDetails,
  AccordionSummary,
  Box,
  Chip,
  Typography,
} from "@mui/material";

import { InvalidField, ParsedForm } from "@/components/FormEngine/types";

import {
  StyledChipContainer,
  StyledErrorAccordion,
  StyledFieldPaper,
  StyledFieldTypography,
  StyledPlaceholder,
  StyledRendererContainer,
} from "./styles";

const InvalidFieldRenderer: React.FC<{ invalidField: InvalidField }> = ({
  invalidField,
}) => (
  <StyledFieldPaper variant='outlined' sx={{ borderColor: "error.main" }}>
    <StyledFieldTypography variant='title2'>
      Name:{" "}
      {invalidField.raw.name || (
        <span style={{ fontStyle: "italic", color: "gray" }}>Nom manquant</span>
      )}
    </StyledFieldTypography>

    <StyledFieldTypography variant='title2' color='text.secondary'>
      Path: {invalidField.id}
    </StyledFieldTypography>

    <Box sx={{ mt: 1.5 }}>
      <Typography
        variant='title1'
        color='error.main'
        sx={{ fontWeight: "bold", mb: 1 }}
      >
        Erreurs détectées :
      </Typography>
      <StyledChipContainer>
        {invalidField.errors.map((error) => (
          <Chip
            key={error.key}
            label={`${error.key} : ${error.message}`}
            size='small'
            color='error'
          />
        ))}
      </StyledChipContainer>
    </Box>
  </StyledFieldPaper>
);

export const AnalyseForm: React.FC<{ analysedForm: ParsedForm | null }> = ({
  analysedForm,
}) => {
  if (!analysedForm) {
    return (
      <StyledPlaceholder>
        Cliquez sur "Générer le formulaire" pour voir le résultat de la
        transformation ici.
      </StyledPlaceholder>
    );
  }

  return (
    <StyledRendererContainer>
      {analysedForm.invalidFields.length > 0 && (
        <StyledErrorAccordion defaultExpanded>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <WarningAmberIcon color='inherit' />
              <Typography variant='title2' sx={{ fontWeight: "bold" }}>
                Champs invalides ou incomplets (
                {analysedForm.invalidFields.length})
              </Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              variant='title1'
              color='text.secondary'
              sx={{ mb: 2, fontStyle: "italic" }}
            >
              Ces champs contiennent des erreurs ou des informations manquantes
              qui empêchent leur traitement correct.
            </Typography>

            {analysedForm.invalidFields.map((invalidField, index) => (
              <InvalidFieldRenderer key={index} invalidField={invalidField} />
            ))}
          </AccordionDetails>
        </StyledErrorAccordion>
      )}
    </StyledRendererContainer>
  );
};
